<template>
  <div class="list">
    <el-col class="marginBtm">
      <el-card class="searchCard" shadow="never">
        <el-form :inline="true" :model="search_form">
          <el-form-item label="上报时间">
            <date-range-picker :value="comeTime" @getChange="dateChange" type="daterange" clearable disabledBeforeDate='-1'></date-range-picker>
          </el-form-item>
          <el-form-item label="通道类型">
            <el-select v-model="search_form.payType" style="width:150px;" clearable placeholder="请选择">
              <el-option v-for="item in thoroughfareList" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="上报状态">
            <el-select v-model="search_form.reportStatus" style="width:150px;" clearable placeholder="请选择">
              <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="授权状态">
            <el-select v-model="search_form.authState" style="width:150px;" clearable placeholder="请选择">
              <el-option :value="0" label="未授权"></el-option>
              <el-option :value="1" label="已授权"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商户编号">
            <el-input style="width:160px;" v-model="search_form.merchantId" auto-complete="off" clearable/>
          </el-form-item>
          <el-form-item label="微信商户号">
            <el-input style="width:160px;" v-model="search_form.wxSubMchId" auto-complete="off" clearable/>
          </el-form-item>
          <el-form-item label="微信渠道号">
            <el-input style="width:160px;" v-model="search_form.channelId" auto-complete="off" clearable/>
          </el-form-item>
          <el-form-item>
            <auth-button opt="search" :plain="true" icon="el-icon-search" @click.native="search" label="查询"></auth-button>
            <auth-button opt="export" :plain="true" icon="el-icon-download" @click.native="exportFile" :loading="exportLoading" label="导出"></auth-button>
          </el-form-item>
        </el-form>
      </el-card>
    </el-col>
    <el-card class="tableCard" shadow="never">
      <el-table stripe style="width: 100%;" v-loading="loading" :data="list" :header-cell-style="{background:'#FAFAFA'}">
        <el-table-column prop="createTime" label="上报时间" width="180" align="center"></el-table-column>
        <el-table-column prop="fmerchantId" label="商户编号" align="center"></el-table-column>
        <el-table-column prop="freportMerchantName" label="商户全称" align="center"></el-table-column>
        <el-table-column prop="fwxSubMchId" label="微信商户号" align="center"></el-table-column>
        <el-table-column prop="fchannelId" label="微信渠道号" align="center"></el-table-column>
        <el-table-column prop="fchannelName" label="渠道号主体" align="center"></el-table-column>
        <el-table-column prop="payTypeStr" label="通道类型" align="center"></el-table-column>
        <el-table-column prop="statusStr" label="上报状态" align="center"></el-table-column>
        <el-table-column prop="authorizeStateStr" label="授权状态" align="center"></el-table-column>
        <el-table-column label="微信公众号支付" align="center">
          <template slot-scope="scope">
            <auth-button opt="set" type="text" size="mini" v-if="scope.row.fwxSubMchId" label="设置"  @click.native="handleWxSetClick(scope.$index, scope.row)"></auth-button>
            <span v-else>---</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="140" align="center">
          <template slot-scope="scope">
            <auth-button opt="update" type="text" v-if="scope.row.fwxSubMchId" label="更新授权状态" @click.native="updataAuthorizestate(scope.row)"></auth-button>
            <span v-else>---</span>
          </template>
        </el-table-column>
        <el-table-column prop="fwxMsg" label="备注" align="center"></el-table-column>
      </el-table>
    </el-card>
    <el-col :span="24" class="btm-action">
      <el-pagination
        v-if="paginations.total>0"
        class="pagination"
        :page-sizes="paginations.pageSizes"
        :page-size="paginations.pageSize"
        :layout="paginations.layout"
        :total="paginations.total"
        :pageNum="paginations.pageNum"
        @current-change="onChangeCurrentPage">
      </el-pagination>
    </el-col>

    <wechat-form :to-set.sync="wxSetDialogVisible" :merchant-id="selectRowId" :payType="selectRowPayType"></wechat-form>
  </div>
</template>

<script>
import qs from 'qs'
import wechatForm from '@/views/merchant/components/wechatForm'
import { updateWxAuthorizestate, queryWxMechant, exportWxMechant } from '@/api/channel'
import dateRangePicker from '@/components/dateRangePicker'
const thoroughfareList = [{ value: 1, label: '线上' }, { value: 2, label: '线下' }, { value: 3, label: '公缴' },
  { value: 4, label: '公益' }, { value: 5, label: '保险' }, { value: 6, label: '绿洲' }, { value: 7, label: '高校食堂' }, { value: 9, label: '服饰日化' }]

const statusList = [{ value: 0, label: '待上报' }, { value: 1, label: '上报成功' },
  { value: 3, label: '上报失败' }, { value: 5, label: '人工禁用' }]

export default {
  name: 'WxMerchant',
  components: {
    wechatForm,
    dateRangePicker
  },
  data () {
    return {
      comeTime: [], // 上报时间
      thoroughfareList, // 通道类型
      statusList, // 上报状态
      search_form: {
        startReportTime: '', // 开始time
        endReportTime: '', // 结束time
        payType: '', // 通道类型
        reportStatus: '', // 上报状态
        authState: '', // 授权状态
        merchantId: '', // 商户编号
        wxSubMchId: '', // 微信商户号
        channelId: '', // 微信渠道号
        pageNo: 1,
        pageSize: 10,
        count: 0
      },
      export_form: {
        moduleCode: 5,
        moduleName: '上报查询',
        menuName: '微信商户'
      },
      selectRowId: '', // 当前操作行的商户id
      selectRowPayType: 1, // 选中行的业务类型，1线上，2线下
      wxSetDialogVisible: false, // 微信公众号支付设置弹窗是否显示

      exportLoading: false,
      merchantWxSetInfo: {
        merchantId: '',
        payType: ''
      },
      wxCongigInfo: {
        appidConfigList: [],
        jsapiPathList: []
      },
      wxConfigInputInfo: {
        sub_appid: '',
        subscribe_appid: '',
        jsapi_path: '',
        subscribeAddList: []
      },
      loading: false,
      list: [],
      paginations: {
        pageNum: 1,
        total: 0,
        pageSize: 10,
        pageSizes: [10],
        layout: 'total, prev, pager, next, jumper'
      }
    }
  },
  mounted () {
    this.setDefaultDate()
    this.getList()
  },
  methods: {
    /**
         * @description 初始日期选择
         */
    setDefaultDate () {
      let end = new Date()
      let start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
      start = start.getFullYear() + '-' + (((start.getMonth() + 1) < 10) ? ('0' + (start.getMonth() + 1)) : (start.getMonth() + 1)) + '-' + ((start.getDate() < 10) ? ('0' + start.getDate()) : (start.getDate())) + ' 00:00:00'
      end = end.getFullYear() + '-' + (((end.getMonth() + 1) < 10) ? ('0' + (end.getMonth() + 1)) : (end.getMonth() + 1)) + '-' + ((end.getDate() < 10) ? ('0' + end.getDate()) : (end.getDate())) + ' 23:59:59'
      this.comeTime = [start, end]
      this.dateChange(this.comeTime)
    },
    /**
         * @description 日期选择器change事件
         */
    dateChange (value) {
      if (value !== null && value.length === 2) {
        this.search_form.startReportTime = value[0] && value[0].length === 10 ? value[0] + ' 00:00:00' : value[0]
        this.search_form.endReportTime = value[1] && value[1].length === 10 ? value[1] + ' 23:59:59' : value[1]
        this.comeTime = [this.search_form.startReportTime, this.search_form.endReportTime]
      } else {
        this.search_form.startReportTime = ''
        this.search_form.endReportTime = ''
        this.comeTime = ['', '']
      }
    },
    /**
         * @description 导出文件
         */
    exportFile () {
      // eslint-disable-next-line no-unused-expressions
      this.paginations.total > 0
        ? ((this.comeTime && this.comeTime.length === 2)
          ? (this.exportLoading = true, this.exportList())
          : this.$message({ showClose: true, message: '请先选择导出日期', type: 'info' }))
        : this.$message({ showClose: true, message: '暂无数据可以导出', type: 'info' })
    },
    exportList () {
      [this.search_form.startReportTime, this.search_form.endReportTime] = this.comeTime
      const data = qs.stringify(Object.assign({}, this.formatSearch(this.search_form), this.export_form))
      exportWxMechant(data).then(res => {
        if (parseInt(res.result_cde) === 0) {
          this.exportLoading = false
          this.$message({
            message: '导出成功，请大约1min后在下载中心中查看并下载',
            type: 'success'
          })
        } else {
          this.exportLoading = false
          this.$message({
            message: res.result_msg,
            type: 'error'
          })
        }
      })
    },
    /**
         * @description 微信商户更新授权状态
         */
    updataAuthorizestate (row) {
      let data = {
        fId: row.fid,
        merchantId: row.fmerchantId,
        wxSubMchId: row.fwxSubMchId
      }
      data = qs.stringify(data)
      updateWxAuthorizestate(data).then(res => {
        if (parseInt(res.result_cde) === 0) {
          this.$message({
            message: '更新成功',
            type: 'success'
          })
        } else {
          this.$message({
            showClose: true,
            message: res.result_msg,
            type: 'error'
          })
        }
      })
    },
    /**
         * @description 微信公众号设置点击
         */
    handleWxSetClick (index, row) {
      this.selectRowId = row.fmerchantId
      this.selectRowPayType = parseInt(row.fpayTypeCode)
      this.wxSetDialogVisible = true // 设置微信公众号
    },
    /**
         * @description 查询列表
         */
    search () {
      // 当点击查询时，显示第一页
      this.search_form.pageNo = 1
      // 让页码数回归到1
      this.paginations.total = 0
      this.getList()
    },
    /**
         * @description 获取列表数据
         */
    getList () {
      this.loading = true
      let data = this.formatSearch(this.search_form)
      data = qs.stringify(data)
      queryWxMechant(data).then((data) => { // queryWxMechant
        if (data.result_cde !== '0') {
          this.$message({
            showClose: true,
            message: data.result_msg || data.error_msg,
            type: 'error'
          })
          this.loading = false
          this.list = []
        } else {
          this.loading = false
          this.paginations.total = data.totalCount
          this.list = data.list
          this.search_form.count = data.totalCount
        }
      })
    },
    /**
         * @description 改变当前页事件
         * @param  {number} page 当前页码
         */
    onChangeCurrentPage (page) {
      const totalCount = this.search_form.count
      this.search_form.pageNo = page
      this.search_form.Count = totalCount
      this.getList()
    },
    /**
         * @description 清除对象中无值属性
         */
    formatSearch (search) {
      var data = Object.assign({}, search)
      for (var s in data) {
        if (!data[s] && data[s] !== 0) {
          delete data[s]
        }
      }
      return data
    }
  }
}
</script>

<style scoped>
  .list{
      padding-left: 16px;
  }
  .pagination{
      margin: 20px 0;
      text-align: center;
  }
</style>
